<div  #dragContainer  class="agent-widget h-100 transition" [class.show]="settings.theme.showSideChat"  [style.display]="settings.theme.showSideChat ? 'block' : 'none'"
        [class.show-chat-window]="showChatWindow">
        <div class="window-controls" >
                <button *ngIf="!global.isMaximized" class="control-btn minimize" (click)="maximizeWindow()" title="Minimize">
                        <i class="fa fa-search-minus" ></i>
                    </button>
                <button *ngIf="global.isMaximized" class="control-btn minimize" (click)="maximizeWindow()"title="Maximize">
                        <i class="fa fa-search-plus"></i>
                    </button>
                <button class="control-btn maximize" (click)="minimizeWindow()" title="Close">
                        <i class="fa fa-times-circle"  ></i>
                    </button>
                    <!-- <button class="control-btn close" (click)="closeWindow()">
                        <i class="fa fa-times-circle-o" style="color: red;"></i>
                    </button> -->
        </div>
        <!-- <p *ngIf="iframeLoadFailed" style="color: red; margin-top: 10px;">
            ⚠️ Failed to load widget. Please refresh the page.
          </p> -->
        <iframe #resizable  id="widgetIframe" [src]="widgetUrl" frameborder="0" style="width: 100%; min-height: 620px" allow="microphone *; display-capture *; fullscreen *" allowfullscreen></iframe>
</div>

